import { useCallback } from "react";

import { usePresentation } from "../presentation";

import { FOLLOWING_QUERY_PARAM } from "components/constants";
import { useAppSelector } from "store/index";
import {
  selectActiveClassSession,
  selectCurrentClassUser,
  selectCurrentSectionId,
  selectIsPresentationActive,
} from "store/selectors";
import { selectIsInBreakout } from "store/selectors/breakouts";
import { useNavigate } from "utils/routing";
import { pageUrl, withQueryParams } from "utils/urls";

export const useFollow = () => {
  const navigate = useNavigate();
  const { isFollowing, isPresenting } = usePresentation();
  const isPresentationActive = useAppSelector(selectIsPresentationActive);
  const classSession = useAppSelector(selectActiveClassSession);
  const presentedPageId = classSession?.presented_page_id;
  const sectionId = useAppSelector(selectCurrentSectionId);
  const isInBreakout = useAppSelector(selectIsInBreakout);
  const classUser = useAppSelector(selectCurrentClassUser);

  const maybeStartFollowing = useCallback(() => {
    if (
      isPresentationActive &&
      !isPresenting &&
      !isFollowing &&
      (!isInBreakout || !classUser?.breakout_group_id) &&
      sectionId &&
      presentedPageId
    ) {
      const presentedPageURL = withQueryParams(pageUrl(sectionId, presentedPageId), {
        [FOLLOWING_QUERY_PARAM]: "1",
      });
      navigate(presentedPageURL);
    }
  }, [
    isPresentationActive,
    isPresenting,
    isFollowing,
    sectionId,
    presentedPageId,
    navigate,
    isInBreakout,
    classUser?.breakout_group_id,
  ]);

  return { maybeStartFollowing };
};
